import { render, staticRenderFns } from "./PageBgCover.vue?vue&type=template&id=2b00f1cc&scoped=true"
import script from "./PageBgCover.vue?vue&type=script&lang=js"
export * from "./PageBgCover.vue?vue&type=script&lang=js"
import style0 from "./PageBgCover.vue?vue&type=style&index=0&id=2b00f1cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00f1cc",
  null
  
)

export default component.exports